/**
 * @description 流程平台工具封装
 * @auth jie.zhang
 */
import { API_CONFIG } from '@/page/config/base_config'
import { getToken } from '@/framework/util/auth'

/**
 * 检测自定义函数是否存在
 * @param {String} 函数名称
 */
export const havaCustomFunction = (functionName) => {
  return (
    window.workFlow &&
    window.workFlow[functionName] &&
    typeof window.workFlow[functionName] === 'function'
  )
}

/**
 * @description 动态加载js文件
 * @param {String} jsPath js文件路径
 * @param {Function} callback 回调函数
 */
export const loadJs = (jsPath, callback) => {
  if (jsPath && jsPath.endsWith('.js')) {
    let pathName = window.document.location.pathname
    let projectName = pathName.substring(0, pathName.substr(1).indexOf('/') + 1)
    let script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = jsPath.indexOf('http') >= 0 ? jsPath : projectName + jsPath
    typeof callback === 'function' && (script.onload = callback)
    document.getElementsByTagName('head')[0].appendChild(script)
  }
}

/**
 * 将元素项设置为只读模式
 * @param {Object} item  元素项
 * @param {Boolean} isDynamic  是否子表单
 */
const setItemOnlyView = (item, isDynamic) => {
  item.disabled = item.frontDelwith = true
  item.readonly = !!isDynamic
  item.placeholder = ' '
  item.required = false
  item.rules = []
  // 只读状态下 子表单禁止新增、删除
  if (item.type === 'dynamic') {
    item.children.addBtn = item.children.delBtn = false
    item.children.column.forEach((element) => {
      setItemOnlyView(element, true)
    })
  }
}
/**
 * @description 控制表单的显示隐藏
 * @param {Array} formItem  表单模型数据项
 * @param {Array} taskSettingArray  流程字段控制
 * @param {Boolean} isView  是否为只读模式
 */
const ProcessingFormSetting = (formItem, taskSettingArray, isView) => {
  // 2020-06-10 by jie.zhang 此处禁用所有组件的clearable, clearable 事件将会导致输入框类型的组件值改变不会触发失去焦点的清空
  formItem.clearable = false
  /** 控制表单的显隐 可读、可写 */
  if (isView || !formItem.display) return setItemOnlyView(formItem)
  if (formItem.disabled) formItem.frontDelwith = true
  let index = taskSettingArray.findIndex(
    (taskItem) => formItem.prop === taskItem.id
  )
  if (index !== -1) {
    if (!formItem.disabled) {
      formItem.frontDelwith = true
      formItem.display = taskSettingArray[index].readable
      formItem.disabled = !taskSettingArray[index].writable
      if (formItem.display && (formItem.disabled || formItem.readonly)) {
        setItemOnlyView(formItem)
      }
    }
  } else {
    // 如果流程引擎没有进行控制的，一律隐藏
    formItem.display = false
  }
}

const uploadWith = (formItem) => {
  if (formItem.type === 'upload') {
    formItem.propsHttp = { res: 'data', url: 'fileUniqueCode', home: API_CONFIG.FDFS_WEB_SERVER_URL }
    if (formItem.action) {
      formItem.action = `${API_CONFIG.API_BASE_URL}${formItem.action}?returnEntity=true`
    } else {
      formItem.action = `${API_CONFIG.API_BASE_URL}/common/document/upload?returnEntity=true`
    }
    formItem.headers = Object.assign(formItem.headers || {}, getToken())
  }
  return formItem
}

/**
 * 表单配置项,单独处理
 * @param {Object} formItem 表单配置项
 */
function PartialFieldProcessing(formItem, taskSettingArray) {
  // 分割线隐藏label
  if (formItem.type === 'divider') {
    formItem.title = formItem.label
    formItem.label = ''
    formItem.labelWidth = 0
  }
  if (formItem.type === 'hyperLink') {
    // formItem.title = formItem.label
    formItem.label = ''
    formItem.labelWidth = 0
  }
  if (formItem.type === 'caption') {
    formItem.label = ''
    formItem.labelWidth = formItem.offset ? formItem.offset : 0
  }
  // value 值回填
  if (formItem.value) {
    if (
      !this.viewFormData.modelData[formItem.prop] ||
      Array.isArray(
        this.viewFormData.modelData[formItem.prop] &&
        this.viewFormData.modelData[formItem.prop].length === 0
      )
    ) {
      this.$set(this.viewFormData.modelData, formItem.prop, formItem.value)
    }
  }
  // 上传组件特殊处理
  formItem = uploadWith(formItem)
  // formItem.onRemove = (file, value) => {//暂不考虑删除服务器附件资源
  //   // this.$http.delete('/common/document/deleteByFileUniqueCode', {
  //   //   params: { fileUniqueCode: file.fileUniqueCode }
  //   // })
  // }
  // 子表单赋值、隐藏
  if (formItem.type === 'dynamic') {
    // 表格模式
    if ((formItem.isTable || formItem.component === 'dynamicForm2') && this.viewFormData.modelData.processInstanceId) {
      // 按钮控制
      let currentAuthority = taskSettingArray.filter(item => item.id === formItem.prop)
      if (currentAuthority.length === 0 || currentAuthority[0].writable === false) {
        formItem.allowAdd = formItem.allowEdit = formItem.allowDel = false
      } else {
        formItem.allowAdd = formItem.allowEdit = formItem.allowDel = true
      }
      let buttonPermissionsMap = new Map()
      if (Array.isArray(taskSettingArray)) {
        taskSettingArray.filter(item => item.id.startsWith(`${formItem.prop}.button.`)).forEach(item => buttonPermissionsMap.set(item.id, item.value))
        // formItem.allowAdd = buttonPermissionsMap.get(`${formItem.prop}.button.add`) !== 'false'
        // formItem.allowEdit = buttonPermissionsMap.get(`${formItem.prop}.button.edit`) !== 'false'
        // formItem.allowDel = buttonPermissionsMap.get(`${formItem.prop}.button.delete`) !== 'false'
      }
      buttonPermissionsMap.forEach((v, k) => {
        if (`${formItem.prop}.button.add` === k) {
          formItem.allowAdd = buttonPermissionsMap.get(`${formItem.prop}.button.add`) !== 'false'
        } else if (`${formItem.prop}.button.edit` === k) {
          formItem.allowEdit = buttonPermissionsMap.get(`${formItem.prop}.button.edit`) !== 'false'
        } else if (`${formItem.prop}.button.delete` === k) {
          formItem.allowDel = buttonPermissionsMap.get(`${formItem.prop}.button.delete`) !== 'false'
        }
      })
      // 字段控制
      let fieldPermissionsMap = new Map()
      taskSettingArray && taskSettingArray.filter(item => item.id.startsWith(`${formItem.prop}.field.`)).forEach(item => fieldPermissionsMap.set(item.id, item.value))
      fieldPermissionsMap.forEach((value, key) => {
        // key : prop.field.
        try {
          let keyItem = key.split('.')
          formItem.children.column.filter(item => item.prop === keyItem[2]).forEach(item => Object.assign(item, JSON.parse(value)))
        } catch (RuntimeException) {
          console.error('流程字段控制错误,请检查。', formItem, RuntimeException)
        }
      })
    }
    formItem.children.column.forEach((item) => {
      // 2020-06-10 by jie.zhang 此处禁用所有组件的clearable, clearable 事件将会导致输入框类型的组件值改变不会触发失去焦点的清空
      item.clearable = false
      // item.span = 12 // 为啥把加工死呢，纯属乱写代码，靠
      item = uploadWith(item)
    })

    if (this.viewFormData.modelData) {
      let value = this.viewFormData.modelData[formItem.prop]
      if (Array.isArray(value)) {
        /**
         * 此处 如果不对对象进行克隆,子表单会存在失去焦点问题,
         * 如果你找到了不克隆对象造成失焦的原因,请将原因写在这里
         * 原因:
         */
        // if (Array.isArray(formItem.defaultDataList)) {
        //   formItem.defaultDataList.forEach((item) =>
        //     value.push(JSON.parse(JSON.stringify(item)))// this.deepClone(item)
        //   )
        // }
      } else {
        this.viewFormData.modelData[formItem.prop] = formItem.defaultDataList ? this.deepClone(formItem.defaultDataList) : []
      }
    }
  }
}

/**
 * 表单事件处理
 * @param {Object} formItem 表单配置项
 */
const bindEvent = function(formItem) {
  // 选出需要绑定 blur事件的组件,其他的全部监听change事件
  let blurComponent = ['input', 'password', 'textarea', 'datetime']
  // 事件对列
  let changeEventQueue = []
  let clickEventQueue = []
  let blurEventQueue = []
  let focusEventQueue = []
  // 翁老板的联动搜索URL
  if (formItem.casUrl) {
    let executiveFunction = () => {
      let bodyData = this.viewFormData.modelData
      bodyData['taskDefinitionKey'] = this.viewFormData.taskDefinitionKey
      this.$http
        .post(`${formItem.casUrl}`, bodyData)
        .then((response) => {
          let columnList = response.data.columnList
          let modifyData = {}
          columnList.forEach((item) => {
            if (item.hasOwnProperty('value')) {
              modifyData[item.prop] = item.value // 记录修改的value值
            }
            setCasUrlValue(this.viewFormData.options.column, item, this)
            if (this.viewFormData.options.group) {
              this.viewFormData.options.group.forEach(groupItem => {
                setCasUrlValue(groupItem.column, item, this)
              })
            }
          })
          // 统一修改数据
          Object.keys(modifyData).forEach(itemKey => {
            if (Array.isArray(modifyData[itemKey])) {
              this.viewFormData.modelData[itemKey] = []
              modifyData[itemKey].forEach(subItem => this.viewFormData.modelData[itemKey].push(this.deepClone(subItem)))
            } else {
              this.$set(this.viewFormData.modelData, itemKey, modifyData[itemKey])
            }
          })
        })
        .catch((error) => {
          this.$message.error(error.msg || error.message)
        })
    }
    blurComponent.includes(formItem.type)
      ? blurEventQueue.push(executiveFunction)
      : changeEventQueue.push(executiveFunction)
  }
  // loadJS 函数触发
  if (formItem.customEvent) {
    let tempEventQueue = blurComponent.includes(formItem.type)
      ? blurEventQueue
      : changeEventQueue
    tempEventQueue.push((e) => {
      if (havaCustomFunction(formItem.customEventName)) {
        window.workFlow[formItem.customEventName].bind(
          this,
          e,
          this.viewFormData.options.column,
          this.viewFormData.modelData,
          this.viewFormData
        )()
      }
    })
  }
  // 事件队列写入
  if (changeEventQueue.length) {
    formItem.change = (e) => changeEventQueue.forEach((item) => item(e))
  }
  if (clickEventQueue.length) {
    formItem.click = (e) => clickEventQueue.forEach((item) => item(e))
  }
  if (blurEventQueue.length) {
    formItem.blur = (e) => blurEventQueue.forEach((item) => item(e))
  }
  if (focusEventQueue.length) {
    formItem.focus = (e) => focusEventQueue.forEach((item) => item(e))
  }

  // 对于blur的以及隐藏的组件, 初始化完成后触发一次它的 blur change事件
  if (blurComponent.includes(formItem.type)) {
    typeof formItem.blur === 'function' && formItem.blur()
  } else {
    typeof formItem.change === 'function' &&
      formItem.change({ column: formItem })
  }
}

function setCasUrlValue(column, item, that) {
  column
    .filter((columnItem) => columnItem.prop === item.prop)
    .forEach((columnItem) => {
      Object.keys(item).forEach((itemKey) => {
        let remoteList = ['select']
        if (itemKey === 'value' &&
      columnItem.remote && columnItem.display && remoteList.indexOf(columnItem.type) >= 0) {
          columnItem.display = !columnItem.display
          setTimeout(() => {
            columnItem.display = !columnItem.display
          }, 0)
        }
        that.$set(columnItem, itemKey, item[itemKey]) // 循环修改字段属性
      })
    // Object.assign(columnItem, item)// 循环修改字段属性
    })
}

const withDicOption2 = (formItem) => {
  const {
    type,
    dicOption
  } = formItem

  if (type === 'select' && dicOption === '2') {
    // custom set
    formItem.formslot = true
  }
}

const withCascader = (formItem) => {
  const {
    type
  } = formItem

  if (type === 'cascader') {
    // custom set
    formItem.formslot = true
  }
}

/**
 * select 机构下拉(静态下拉，已存数据也通用)
 * @param {Object} formItem 表单配置项
 */
function noDicDataAlreadyHasValue(formItem) {
  if (formItem.dicOption === '1' && formItem.dicData.length === 0) {
    let val = this.viewFormData.modelData[formItem.prop]
    if (val && val !== '' && this.viewFormData.modelData && this.viewFormData.modelData['selectMap']) {
      let text = JSON.parse(this.viewFormData.modelData['selectMap'])['$' + formItem.prop]
      formItem.dicData.push({ label: text, value: val })
    }
  }
}

const withMaxMinDate = (formItem) => {
  const timeTypes = ['time']
  const dateTypes = ['year', 'month', 'week', 'date', 'daterange', 'datetime', 'datetimerange']
  const {
    type,
    maxDate,
    minDate
  } = formItem

  if (dateTypes.includes(type)) {
    // formItem.disabled = false
    formItem.pickerOptions = {}
    formItem.pickerOptions.disabledDate = (time) => {
      const minTime = (new Date(minDate)).getTime()
      const maxTime = (new Date(maxDate)).getTime()
      const currentTime = time.getTime()
      if (minDate && maxDate) {
        return !(currentTime >= minTime && currentTime <= maxTime)
      } else if (minDate) {
        return !(currentTime >= minTime)
      } else if (maxDate) {
        return !(currentTime <= maxTime)
      }
    }
  }

  // custom set
  if (timeTypes.includes(type)) {
    if (formItem.mode !== '2') {
      formItem.formslot = true
    }
  }
}

/**
 * @description 处理流程返回数据
 * @param {Array} formSettingArray  表单模型数据
 * @param {Array} taskSettingArray  流程字段控制
 * @param {Boolean} isView  是否为只读模式
 */
export function HandleForm(formSettingArray, taskSettingArray, isView) {
  formSettingArray.forEach((formItem) => {
    // 控制表单的显示隐藏
    ProcessingFormSetting.bind(this, formItem, taskSettingArray, isView)()
    if (isView === true) {
      taskSettingArray = []
    }
    // 部分字段处理
    PartialFieldProcessing.bind(this, formItem, taskSettingArray)()

    const { noDisplayIfNull, disabled, value, prop } = formItem
    if (disabled && noDisplayIfNull) {
      if (value === null || value && value.length === 0) {
        formItem.display = false
      }

      const newVal = this.viewFormData.modelData[prop]
      if (newVal && newVal.length === 0) {
        formItem.display = false
      } else if (!(newVal && newVal.length)) {
        formItem.display = false
      }
    }

    noDicDataAlreadyHasValue.bind(this, formItem)()

    // 事件绑定
    bindEvent.bind(this, formItem)()

    // 远端下拉
    withDicOption2(formItem)

    // 级联菜单
    withCascader(formItem)

    // 日期时间最大最小值
    withMaxMinDate(formItem)
  })
}
